<template>
  <div>
    <v-dialog v-model="loading"  persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container>
      <v-row>
        <v-col cols="12">
          <span class="screenHeading">In process MOCs massive user replacement details</span>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" sm="10">
          <v-card>
            <v-container>
              <v-row>
                <v-col cols="5" sm="4">
                  <span>
                    Replaced:
                    <strong>{{ oldUser }}</strong>
                  </span>
                </v-col>
                <v-col cols="2">
                  <v-icon medium>mdi-arrow-right</v-icon>
                </v-col>
                <v-col cols="5" sm="4">
                  <span>
                    Replaced by:
                    <strong>{{ newUser }}</strong>
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="10">
                  <span>
                    Community:
                    <strong>{{ community }}</strong>
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" sm="10">
          <v-data-table class="elevation-1" :headers="headers" :items="items" >
            <template v-slot:item="props">
              <tr>
                <td>
                  <a :href="`/${props.item.mocId.substring(0, 3)}/moc/${props.item.mocId}`" target="_blank">{{props.item.mocId }}</a>
                </td>
                <td>
                  <span>{{ getRolesMatched(props.item) }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="10" class="content-end">
          <i>Triggered by {{ insertedBy }} on {{ $filters.DateTimeFilter(insertedByDate)}}</i>
        </v-col>
      </v-row>
    </v-container>

    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import Toaster from '@/components/Toaster'
import MOCService from '@/services/moc.service'
import { Roles } from '@/common'

export default {
  components: {
    Toaster
  },
  data() {
    return {
      loading: false,
      items: [],
      headers: [{ title: 'Moc Id', key: 'mocId', sortable: false }, { title: 'Replaced in', sortable: false }]
    }
  },
  computed: {
    insertedBy() {
      return this.items.length ? this.items[0].insertedBy.displayName : ''
    },
    insertedByDate() {
      return this.items.length ? this.items[0].insertedByDate : ''
    },
    community() {
      return this.items.length ? this.$route.params.communityAbbreviation : ''
    },
    oldUser() {
      return this.items.length ? this.items[0].oldUser.displayName : ''
    },
    newUser() {
      return this.items.length ? this.items[0].newUser.displayName : ''
    }
  },
  methods: {
    getRolesMatched(item) {
      return item.found
        .map(r => {
          if (r === 'response-relationship-approver') return 'Response Relationship (Approver)'
          if (r === 'response-relationship-fyi') return 'Response Relationship (FYI)'
          if (r === 'vp') return Roles.properties[r].name
          return Roles.properties[r] ? Roles.properties[r].name : ''
        })
        .join(', ')
    }
  },
  created() {
    if (this.loading) return
    this.loading = true
    MOCService.getUserReplacementByReference(this.$route.params.communityAbbreviation, this.$route.params.reference)
      .then(succ => (this.items = succ))
      .catch(() => {
        this.$refs.toaster.pop('error', 'Failed to retrieve data')
      })
      .finally(() => (this.loading = false))
  }
}
</script>
<style scoped>
.content-end {
  justify-content: flex-end;
  display: flex;
}

.v-dialog__container {
    display: unset; 
}
</style>
